export interface OidcTokenInfo {
  token: string;
  expiresAt?: number;
}

export interface AuthSessionState {
  latestOidcToken: OidcTokenInfo | null;
  humhubExpiresAt?: number;
}

const authSessionState: AuthSessionState = {
  latestOidcToken: null,
  humhubExpiresAt: undefined,
};

export const getAuthSessionState = (): AuthSessionState => ({
  latestOidcToken: authSessionState.latestOidcToken,
  humhubExpiresAt: authSessionState.humhubExpiresAt,
});

export const getLatestOidcToken = (): OidcTokenInfo | null =>
  authSessionState.latestOidcToken;

export const getHumhubExpiresAt = (): number | undefined =>
  authSessionState.humhubExpiresAt;

export const recordOidcRefreshSuccess = (tokenInfo: OidcTokenInfo) => {
  authSessionState.latestOidcToken = tokenInfo;
};

export const recordHumhubSessionLogin = ({
  humhubExpiresAt,
  oidcToken,
}: {
  humhubExpiresAt?: number;
  oidcToken: OidcTokenInfo;
}) => {
  authSessionState.latestOidcToken = oidcToken;
  authSessionState.humhubExpiresAt = humhubExpiresAt;
};

export const invalidateRefreshTokenSession = () => {
  authSessionState.latestOidcToken = null;
  authSessionState.humhubExpiresAt = undefined;
};

export const clearAuthSessionState = () => {
  authSessionState.latestOidcToken = null;
  authSessionState.humhubExpiresAt = undefined;
};
